
import * as types from './mutation-types.js'

import store from '../story/'



export default {

/*  async getCartlist({
    commit,
    state
  }) {
    let res = await getData.shoppingCartNum();
    commit(types.SAVE_CARTLIST, res.shoppingCartNum)
  }*/

}



// WEBPACK FOOTER //
// ./src/story/action.js